
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Youtube Specialist 
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Job Description: </h3>
              <p> A YouTube specialist develops and implements marketing strategies for the YouTube platform. They use YouTube's features, tools, and analytics to increase conversions and engage audiences</p>
                <!-- <p>	Certified Digital Marketer with relevant practical experience is Preferred.</p>
                <p>	Minimum of 3-5 years of experience as a Digital Marketing Executive or Social Media Manager</p> -->
            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>KEY RESPONSIBILITIES: </h3>
              <p><span class="step_no">1</span> Creating and launching a YouTube channel</p>
              <p><span class="step_no">2</span> Conducting research on competitors and target audiences </p>
              <p><span class="step_no">3</span>	Optimizing videos for maximum views</p>
              <p><span class="step_no">4</span>	Creating title tags</p>
              <p><span class="step_no">5</span>	Maximizing exposure through SEO</p>
              <p><span class="step_no">6</span>	Selecting thumbnails.</p>
              <p><span class="step_no">7</span>	Increasing subscriber numbers</p>
              <p><span class="step_no">8</span>	Leveraging videos across other social media platforms</p>
              <p><span class="step_no">9</span> Defining and implementing channel strategy</p>
              <p><span class="step_no">10</span> Managing channel content </p>
            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <!-- <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Job requirement: </h3>
              <p> Photographer to cover MSDE events / meetings / training in centres in Delhi</p>

            </div>
          </div>
        </div> -->
        <!-- feature box close -->


  <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p>Rs. 1,500 Per Day. </p>

      </div>
    </div>
  </div> -->
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 20th December 2024 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
<!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Key Responsibility:</h3>
		
        <p> <span class="step_no">1</span> Photography </p>
        <p> <span class="step_no">2</span>Managing the daily/weekly/monthly agenda and arrange new meetings / workshops and scheduling appointments, 
            taking Minutes of the meeting </p>
        <p> <span class="step_no">3</span>Make travel arrangements,</p>
        <p><span class="step_no">4</span>Excellent written and verbal communication skills </p>
        <p><span class="step_no">5</span>organizing files </p>
        <p><span class="step_no">6</span>Able to prepare documents / reports / PPTs, etc.</p>
        <p><span class="step_no">7</span>Dynamic and self-going</p>
        <p><span class="step_no">8</span>Coordination with the team and client including all the stakeholders and ensure all project deliverables are 
            submitted within stipulated time and ensure high quality deliverables.</p>
        <p><span class="step_no">9</span>Build partnerships and linkages with SSCs, private sectors 
            and other stakeholders for smooth implementation of programme. </p>
                <p><span class="step_no">10</span>Actively protcting the institutes interest in every aspect of 
                    delivery including complying with statutory regulations maintaining highest standards of quality of the 
                    engagement and ensuring that the potential risk to institute 
                    arising out of operational lapses are minimized</p>
                    <p><span class="step_no">11</span>Conversant with MS-Office and different e-mail platform</p>
                        <p><span class="step_no">12</span>Able to take notes and draft as per requirement</p>

      </div>
    </div>
  </div> -->
  <!-- feature box close -->
  <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
		
                  <p> <span class="step_no">1</span>Excellent writing and communication skills</p>
        <p> <span class="step_no">2</span>Strong analytical and documentation skills</p>
        <p> <span class="step_no">3</span>Experience of using automated accounting applications and MS Office</p>
			

        <p> <span class="step_no">4</span>Strong presentation skills and interpersonal skills</p>

		 <p> <span class="step_no">5</span>Should be able to operate in unstructured environment with minimal support.</p>
 <p> <span class="step_no">6</span>Openness to travel if required</p>





      </div>
    </div>
  </div> -->
  <!-- feature box close -->

    <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Key responsibilities:</h3>
        
			
<p><span class="step_no">1</span>Design, implement and Support financial management systems and procedures
</p>
<p><span class="step_no">2</span>Ensure fulfil1ment of requirements as laid under the financial management manual of SANKALP</p>
<p><span class="step_no">3</span>Prepare necessary financial reports including budget preparation, maintaining books of accounts, statement of expenditure etc.</p>
<p><span class="step_no">4</span>Support MSDE and other	stakeholders for fulfilling	audit requirements of SANKALP</p>
<p><span class="step_no">5</span>Support in bringing collaboration and partnership with various stakeholders.</p>
<p><span class="step_no">6</span>Develop periodic reports as per MSDE requirements</p>
<p><span class="step_no">7</span>Any other work as per MSDE requirement.</p>

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->

          <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Period of Contract:</h3>
            <p>11 Months (extendable)</p>

           

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->

 <!-- feature box begin -->
 <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card</p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates</p>
		


      </div>
    </div>
  </div>
      <!-- feature box close -->
    
    <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow"> 
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
       		<p>NIMI, Chennai</p>
      </div>
    </div>
  </div> 
  <!-- feature box close -->

 <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Division</h3>
       		<p>Media Division</p>





      </div>
    </div>
  </div>
  <!-- feature box close -->


  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="https://nimiprojects.in/nimirecruitment/#/vacancy" target="blank" class="btn-custom scroll-to">Job Listing</a>
</div>


  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div>


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>




